/* components/SiteHeader.ts
Global Site Header

Example
<site-header>
	Site header content here
</site-header>
*/

import { AnnouncementBar } from '../AnnouncementBar/AnnouncementBar';
import { CartMain } from "../Cart/CartMain";
import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { debounce } from 'lodash';
import { SideCart } from '../SideCart/SideCart';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { cart } from '@/theme/Cart';

@Component
export class SiteHeader extends ThemeComponent {
    @Ref() row!: HTMLDivElement;
    @Ref({required: false}) searchMenutoggle!: HTMLDivElement;
    @Ref({ required: false }) cartTrigger!: HTMLDivElement;
    @Ref() menuToggle!: HTMLButtonElement;
    @Ref({ required: false }) count!: HTMLElement;
    @Ref({ required: false }) announcement!: AnnouncementBar;

    private _onOpenChange = new SimpleEvent<string>();
    private sideCart: SideCart | null = document.body.querySelector('side-cart');

    public get onOpenChange() {
        return this._onOpenChange.asEvent();
    }

    public changeOpen(open: string) {
        // Use the private backing field to dispatch
        this._onOpenChange.dispatch('');
    }

    init() {
        this.handleBodyPadding();
        this.setEventListeners();

        const cartMain = document.body.querySelector('cart-main') as CartMain;
        document.addEventListener('cartChanged', (e: Event) => {
            this.updateCartCount();
        });
        document.addEventListener('cartChangedLightDarkText', (e: Event) => {
            this.updateCartCount();
        });
    }

    /**
	 * Set event listeners.
	 */
    setEventListeners() {
        this.$listen(window, 'resize',
            debounce(() => {
                this.handleBodyPadding();
            }, 300)
        );

        this.handleScroll();
        this.cartEvent();
        this.menuEvent();

        if (!this.searchMenutoggle) { return; }
        document.addEventListener('toggle', () => {
            this.searchMenutoggle.classList.toggle('hidden-above-small-desktop');
        });
    }

    /**
	 * Handle Body Paddin
	 */
    private handleBodyPadding() {
        const height = this.offsetHeight;
        // document.body.style.paddingTop = `${height}px`;

        const vw = document.documentElement.clientWidth / 100;
        document.documentElement.style.setProperty('--vw', `${vw}px`);
    }

    private handleScroll() {
        const headerHeight = this.offsetHeight;
        const header = this.closest('header');
        let height = 0;
        window.addEventListener('scroll', (e) => {
            if ((window.scrollY > headerHeight || window.scrollY > 15) && window.scrollY > height) {
                header?.classList.add('site-header--down');
                header?.classList.remove('site-header--up');
                // this.announcement.classList.remove('visually-hidden');
            } else if (window.scrollY > headerHeight && window.scrollY < height) {
                header?.classList.add('site-header--up');
                header?.classList.remove('site-header--down');
                // this.announcement.classList.add('visually-hidden');
            } else if (window.scrollY < 15) {
                header?.classList.remove('site-header--down');
                header?.classList.remove('site-header--up');
                // this.announcement.classList.remove('visually-hidden');
            }
            height = window.scrollY;
        });
    }
    /**
	 * Cart Close click event.
	 * @returns
	 */
    cartEvent() {
        if (!this.cartTrigger) { return; }
        this.$listen(this.cartTrigger, 'click', (event) => {
            event.preventDefault();

            if (!this.sideCart) { return; }
            this.sideCart.open();
        });
    }

    menuEvent() {
        this.$listen(this.menuToggle, 'click', (event) => {
            event.preventDefault();
            document.dispatchEvent(new Event('openMenu'));
        });
    }

    /**
	 * Update cart count
	 * @returns
	 */
    private updateCartCount() {
        const count = cart.getCartItemCount();
        this.count.innerHTML = count.toString();

        if (count > 0) {
            this.count.parentElement?.classList.add('is-active');
        } else {
            this.count.parentElement?.classList.remove('is-active');
        }
    }
}
